import { render, staticRenderFns } from "./GerenciaRelatorioPedagogico.vue?vue&type=template&id=6168756f"
import script from "./GerenciaRelatorioPedagogico.vue?vue&type=script&lang=js"
export * from "./GerenciaRelatorioPedagogico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports